module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/sell-property-videocall.c1d0831d073784d10b8b2ac69a80c611.jpg";